import { combineReducers } from 'redux';
import CoinReducer from './CoinReducer';
import CollateralReducer from './CollateralReducer';
import ExchangeReducer from './ExchangeReducer';
import SetupBizReducer from './SetupBizReducer';
import SetupReducer from './SetupReducer';
import SetupTechReducer from './SetupTechReducer';
import StatReducer from './StatReducer';
import UserReducer from './UserReducer';
import BillingReducer from './BillingReducer';
import PairReducer from './PairReducer';
import TradeReducer from './TradeReducer';
import ConstantReducer from './ConstantReducer';
import VerifyAgreeReducer from './VerifyAgreeReducer';
import PluginReducer from './PluginReducer';

const rootReducer = combineReducers({
	coin: CoinReducer,
	collateral: CollateralReducer,
	exchange: ExchangeReducer,
	setup: SetupReducer,
	biz: SetupBizReducer,
	tech: SetupTechReducer,
	stat: StatReducer,
	user: UserReducer,
	invoice: BillingReducer,
	pair: PairReducer,
	trade: TradeReducer,
	constant: ConstantReducer,
	verifyAgree: VerifyAgreeReducer,
	plugin: PluginReducer,
});

export default rootReducer;
